import { Box, IconButton, Stack, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { ApplicationQuestion } from '@features/applicationQuestions';
import { medium } from '@styles/fontWeights';
import { Delete, Edit } from '@mui/icons-material';
import { useGetEmployerTags } from '@features/applications/hooks/useGetEmployerTags';
import DeleteApplicationQuestionModal from '../DeleteApplicationQuestionModal/DeleteApplicationQuestionModal';
import ApplicationQuestionModal from '../ApplicationQuestionModal/ApplicationQuestionModal';

type ApplicationQuestionListItemProps = {
  question: Partial<ApplicationQuestion>;
  index: number;
};

const ApplicationQuestionListItem: FC<ApplicationQuestionListItemProps> = ({
  question,
  index,
}) => {
  const [selectedQuestion, setSelectedQuestion] =
    useState<ApplicationQuestion | null>(null);
  const [errorText, setErrorText] = useState('');
  const [isApplicationQuestionModalOpen, setIsApplicationQuestionModalOpen] =
    useState(false);
  const [
    isDeleteApplicationQuestionModalOpen,
    setIsDeleteApplicationQuestionModalOpen,
  ] = useState(false);

  const { tagsData: employerTagData, isLoadingTags: isLoadingEmployerTags } =
    useGetEmployerTags({
      setErrorText,
      enabled: true,
    });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        borderRadius: '8px',
        backgroundColor: 'background.paper',
        boxShadow: 1,
        marginBottom: '12px',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 3,
        },
      }}
    >
      <Stack direction="row">
        <Typography
          variant="h6"
          fontWeight={medium}
          color="primary.main"
          sx={{ width: '40px', textAlign: 'center' }}
        >
          {index + 1}.
        </Typography>

        <Typography
          variant="body1"
          fontWeight={medium}
          color="text.primary"
          sx={{ flexGrow: 1, marginLeft: '12px' }}
        >
          {question.label}
        </Typography>
      </Stack>
      <Stack direction="row">
        <IconButton
          onClick={() => {
            setSelectedQuestion(question as ApplicationQuestion);
            setIsApplicationQuestionModalOpen(true);
          }}
        >
          <Edit color="primary" />
        </IconButton>
        <IconButton
          onClick={() => {
            setSelectedQuestion(question as ApplicationQuestion);
            setIsDeleteApplicationQuestionModalOpen(true);
          }}
        >
          <Delete color="error" />
        </IconButton>
      </Stack>

      <DeleteApplicationQuestionModal
        isOpen={isDeleteApplicationQuestionModalOpen}
        handleClose={() => {
          setIsDeleteApplicationQuestionModalOpen(false);
          setSelectedQuestion(null);
        }}
        applicationQuestion={selectedQuestion}
      />
      {isApplicationQuestionModalOpen && (
        <ApplicationQuestionModal
          isOpen={isApplicationQuestionModalOpen}
          applicationQuestion={selectedQuestion}
          employerTagData={employerTagData}
          handleClose={() => {
            setSelectedQuestion(null);
            setIsApplicationQuestionModalOpen(false);
          }}
        />
      )}
    </Box>
  );
};

export default ApplicationQuestionListItem;
